module.exports = __webpack_public_path__ + "img/metrics.8fdae395.png";